import { createUseStyles } from 'react-jss';

import { ITheme } from '../../../../../styles';

const useStyles = createUseStyles(
  ({ breakpoints }: ITheme) => ({
    root: {
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'space-between',
    },

    text: {
      color: 'var(--x-text-color-5)',
      fontSize: 14,
      fontWeight: 600,
      flexGrow: 1,
      marginInline: 8,
    },

    left: {
      alignItems: 'center',
      display: 'flex',
    },

    isRound: {
      '&>div': {
        borderRadius: '50%',
      },
    },

    right: {
      display: 'flex',
      gap: 8,
    },

    arrow: {
      fill: '#000',
    },

    newTag: {
      backgroundColor: 'var(--x-new-label-color)',
      borderRadius: 72,
      color: '#fff',
      fontSize: 10,
      fontWeight: 600,
      lineHeight: '14px',
      paddingInline: 6,
    },

    newTabIcon: {
      fill: 'var(--x-textf-field-color-1)',
      height: 16,
      width: 16,
    },
  }),
  { name: 'NavMenuItem' },
);

export default useStyles;
